<template>
  <el-config-provider :locale="locale">
    <router-link to="/"></router-link> 
    <router-view />
  </el-config-provider>
</template>
<script>
  import { defineComponent } from 'vue'
  import { ElConfigProvider } from 'element-plus'

  import ja from 'element-plus/lib/locale/lang/ja'

  export default defineComponent({
    components: {
      ElConfigProvider,
    },
    setup() {
      return {
        locale: ja,
      }
    },
  })
</script>